export const DEFAULT_PAGE_SIZE = process.env.DEFAULT_PAGE_SIZE
  ? parseInt(process.env.DEFAULT_PAGE_SIZE, 10)
  : 8
